import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import ScoreRecords from "../scoreRecords/scoreRecords";
import _ from "lodash";
import {toJS} from "../hocs/toJs";
import {_isAdmin, _isDepartmentUser} from "../../helpers/functions";
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortScoreRecordsForm');

const parseScoreRecords = (scoreRecords) => {

  return scoreRecords.valueSeq().toArray().map(scoreRecord => ({
    id: scoreRecord.get('id'),
    createdDate: scoreRecord.get('createdDate'),
    personId: scoreRecord.get('personId'),
    person: {
      id: scoreRecord.getIn(['person','id']),
      username: scoreRecord.getIn(['person','username']),
      email: scoreRecord.getIn(['person','email']),
      department: scoreRecord.getIn(['person'])
    },
  }));
};

const parseRoles = (roles) => {
  const parsedNews = [];
  roles.valueSeq().toArray().forEach(role => (
    parsedNews.push({
      id: role.get('id'),
      name: role.get('name'),
    })));
  return parsedNews;
};

class ScoreRecordsHOC extends Component {

  componentDidMount(){
    this.props.getDepartments({filter:{where: {or: [{deleted: false}, {deleted: null}]}}});

    //get score records based on user role
    let whereFilter = null;
    if(_isAdmin(this.props.personRoles)){
      whereFilter = {};
    }
    if(_isDepartmentUser(this.props.personRoles)){
      whereFilter = {departmentId: this.props.loggedInPersonDepartmentId};
    }
    this.props.getScoreRecords({
      filter: {
        order:  'createdDate DESC',
        include: [
          {relation: 'person', scope: {include: 'department'}},
          {relation: 'scores', scope: {
            include: ['store', {relation: 'criteria', scope: {include: 'department'}}],
              limit: 1
          }}
        ],
        where: whereFilter
      }
    });
  }

  submitFile = (formIM) => {
    let form = formIM.toJS();
    const formData = new FormData();
    _.forEach(form.file, file => {
      formData.append('file', file)
    });

    this.props.createScoreRecordFromFile({
      sendBody: formData
    })
  };

  filterScoreRecords = (formIM) => {
    let form = formIM.toJS();
    this.props.filterScoreRecordsLocally({
      filterForm: form
    })
  };

  render(){
    return (
      <ScoreRecords
        {...this.props}
        submitFile={this.submitFile}
        filterScoreRecords={this.filterScoreRecords}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInPersonDepartmentId: state.loggedInPerson.get('departmentId'),
    scoreRecords: state.scoreRecords.get('scoreRecords'),
    personRoles: state.loggedInPerson.get('roles'),
    loading: state.scoreRecords.get('fetching'),
    postingFile: state.scoreRecord.get('postingFile'),
    uploadModalOpen: state.scoreRecord.get('uploadModalOpen'),
    postingFileMessage: state.scoreRecord.get('postingFileMessage'),
    fetchingScoreRecord: state.scoreRecord.get('fetching'),
    deleteScoreRecordMessage: state.scoreRecord.get('deleteScoreRecordMessage'),
    deletingScoreRecord: state.scoreRecord.get('deleting'),
    departments: state.departments.get('departments'),
    filterModalOpen: state.scoreRecords.get('filterModalOpen'),
    postingFileInvalidScores: state.scoreRecord.get('postingFileInvalidScores'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScoreRecords: (payload) => {
      dispatch(actions.getScoreRecords(payload))
    },
    createScoreRecordFromFile: (payload) => {
      dispatch(actions.createScoreRecordFromFile(payload))
    },
    openUploadModal: (payload) => {
      dispatch(actions.openUploadModal(payload))
    },
    closeUploadModal: (payload) => {
      dispatch(actions.closeUploadModal(payload))
    },
    changeScoreRecordState: (payload) => {
      dispatch(actions.changeScoreRecordState(payload))
    },
    deleteScoreRecord: (payload) => {
      dispatch(actions.deleteScoreRecord(payload))
    },
    getDepartments: (payload) => {
      dispatch(actions.getDepartments(payload))
    },
    filterScoreRecordsLocally: (payload) => {
      dispatch(actions.filterScoreRecordsLocally(payload))
    },
    openScoreRecordsFilterModal: (payload) => {
      dispatch(actions.openScoreRecordsFilterModal(payload))
    },
    closeScoreRecordsFilterModal: (payload) => {
      dispatch(actions.closeScoreRecordsFilterModal(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ScoreRecordsHOC));



// WEBPACK FOOTER //
// ./src/components/scoreRecords/scoreRecordsHOC.js